// extracted by mini-css-extract-plugin
export default {"switch":"SwitchDirectionButton_switch__euwcw","switchButton":"SwitchDirectionButton_switchButton__oghwN","anim":"SwitchDirectionButton_anim__L2V5T"};